<template>
  <TheSaib v-if="$store.state.auth.isSignin">
    <template v-slot:buttons>
      <a-button
        shape="round"
        style="margin: 5px;"
        type="primary"
        icon="file-done"
        class="fl-right"
        @click="addNewSaibs"
      >완료</a-button>
    </template>
    <table class="list-type-2">
      <thead>
        <tr>
          <td>No.</td>
          <td>매장 이름</td>
          <td v-if="isPC">
            위치
            <br />소속상가(층/열/호)
          </td>
          <td v-if="isPC">예상 금액</td>
          <td v-if="isPC" class="order-detail">주문 내역</td>
        </tr>
      </thead>
      <tbody>
        <SaibApplyItem
          v-for="(saib, index) in $store.state.saib.newSaibs"
          :key="index"
          :idx="saib.idx"
          :wholesale="saib.wholesale"
          :name="saib.name"
          :location="saib.location"
          :price="saib.price"
          :details="saib.details"
        />
      </tbody>
    </table>
  </TheSaib>
</template>
<script>
import TheSaib from "@/components/Saib/TheSaib";
import SaibApplyItem from "@/components/Saib/SaibApplyItem";
import { mapActions } from "vuex";

export default {
  name: "SaibStatus",
  components: { TheSaib, SaibApplyItem },
  methods: {
    ...mapActions(["addNewSaibs"])
  }
};
</script>